import React from "react";
import { useLang } from "@/i18n";

export function LangToggle() {
  const { lang, setLang } = useLang();
  return (
    <div className="inline-flex rounded-lg border border-slate-200 bg-white overflow-hidden text-sm font-semibold shrink-0" data-testid="lang-toggle">
      <button
        data-testid="lang-en"
        onClick={() => setLang("en")}
        className={`px-3 py-1.5 transition-colors ${lang === "en" ? "bg-slate-800 text-white" : "text-slate-500"}`}
      >EN</button>
      <button
        data-testid="lang-hi"
        onClick={() => setLang("hi")}
        className={`px-3 py-1.5 transition-colors ${lang === "hi" ? "bg-slate-800 text-white" : "text-slate-500"}`}
      >हिंदी</button>
    </div>
  );
}
